import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import GestioneDocumentiTable from "./GestioneDocumentiTable/Table/GestioneDocumentiTable";
import GestioneDocumentFilter from "./GestioneDocumentiTable/ControlCockPit/GestioneDocumentFilter";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import { labelForFilterDocUser } from "../../../utils/functions/filters";
import {
  useDeleteAllDocumentsMutation,
  useGetDocumentManagementQuery,
} from "../../api/user/gestisciDocumentiApi";
import { useGetUserCategoriesQuery } from "../../api/user/categoriesApi";
import { actions as actionCategories } from "../../../app/categoriesSlice";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import GestioneDocumentiStats from "../../admin/GestioneDocumentiPage/GestioneDocumentiTable/ControlCockpit/GestioneDocumentiStats";
import GestioneDocumentiButtonCockpit from "./GestioneDocumentiTable/ControlCockPit/GestioneDocumentiButtonCockpit";
import { Tab, Tabs } from "@mui/material";

const GestioneDocumentiPage = () => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const [selectedYear, setSelectedYear] = useState(null);
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    mainCategoryId: "",
    subCategoryId: "",
    dateFrom: "",
    dateTo: "",
  });
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("createdAt");
  // Data from API
  const { data, isLoading, isFetching, error, refetch } =
    useGetDocumentManagementQuery({
      page,
      filter,
      orderDirection,
      valueToOrderBy,
    });
  const { data: userCategories } = useGetUserCategoriesQuery();

  const [deleteDocuments, { isLoading: isDeletingDocument }] =
    useDeleteAllDocumentsMutation();

  // Hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categories = useSelector((state) => state.categories.macroCategories);

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) {
        newFilter[k] = "";
        if (k === "dateTo") newFilter["dateFrom"] = "";
      }
    });
    setFilter(newFilter);
    setSelectedYear(null);
  };

  useEffect(() => {
    if (userCategories?.Data)
      dispatch(actionCategories.setMacroCategories(userCategories?.Data));
  }, [userCategories, dispatch]);

  const handleRefecthDocuments = () => {
    refetch();
  };

  return (
    <>
      {isLoading ? (
        <CoreSpinner />
      ) : (
        <div className="flex flex-col">
          <div className="flex items-center">
            <h2 style={{ width: "200px" }}>{t("SmartArchive")}</h2>
            {appConfig?.modules?.documents?.folders && (
              <Tabs value={0}>
                <Tab
                  className="text-mont text-capitalize fs-6"
                  label={"Tabella"}
                />
                <Tab
                  className="text-mont text-capitalize fs-6"
                  label={"Cartelle"}
                  onClick={() => navigate("folder")}
                />
              </Tabs>
            )}
          </div>
          <div>
            <div className="flex flex-row -mt-16 justify-end space-x-2">
              {Object.entries(filter).map(
                ([k, v]) =>
                  k !== "dateFrom" &&
                  v !== "" && (
                    <CoreChip
                      key={v}
                      label={labelForFilterDocUser(k, v, categories)}
                      variant="outlined"
                      onDelete={() => handleRemoveFilter(v)}
                    />
                  )
              )}

              <GestioneDocumentFilter
                filter={filter}
                setFilter={setFilter}
                selectedYear={selectedYear}
                setSelectedYear={setSelectedYear}
              />
            </div>

            <div className="py-5 w-full flex justify-between items-center">
              <div className="flex">
                <CoreButtonHoverIcon
                  onClick={handleRefecthDocuments}
                  className="text-blue-500 m-1 flex flex-row space-x-2 border"
                  testo={t("Refresh")}
                  icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
                />
                <CoreButtonHoverIcon
                  onClick={() => navigate(`/auth/user/${t("uploadDocuments")}`)}
                  className="text-green-500 m-1 flex flex-row space-x-2 border"
                  testo={t("Upload")}
                  icon={<UploadFileRoundedIcon className={`fill-green-500`} />}
                />
              </div>

              <div className="w-2/3 ml-2">
                <GestioneDocumentiButtonCockpit
                  data={data?.Data?.items}
                  isDeleteLoading={isDeletingDocument}
                  deleteDocuments={deleteDocuments}
                />
              </div>
              <div className="flex w-fit">
                <GestioneDocumentiStats data={data?.Data} />
              </div>
            </div>
            <GestioneDocumentiTable
              page={page}
              setPage={setPage}
              data={data?.Data}
              valueToOrderBy={valueToOrderBy}
              setValueToOrderBy={setValueToOrderBy}
              orderDirection={orderDirection}
              setOrderDirection={setOrderDirection}
              isLoading={isLoading || isFetching}
              totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
              refetch={refetch}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GestioneDocumentiPage;
